/* eslint-disable no-nested-ternary */
import { LoadingButton } from '@mui/lab';
import { Box, Card, Stack, TextField, Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import FormProvider from 'src/components/hook-form';
import { toastError } from 'src/utils/format-error';
import { enqueueSnackbar } from 'notistack';
import { useBoolean } from 'src/hooks/use-boolean';

import { useState, useEffect } from 'react';
import LoadingContainer from 'src/components/ui-kit/loading-container';
import { SettingType, SystemConfigKey } from 'src/type/settings';
import axios, { endpoints } from 'src/utils/axios';
import UpdatedText from 'src/components/ui-kit/updated-text';
import { fNumber } from 'src/utils/format-number';
import { getSettingUpdated } from '../../utils';

export default function SettingLv0Balance() {
  const reload = useBoolean();
  const initialize = useBoolean(true);
  const [settings, setSettings] = useState(Array<SettingType>());

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      [SystemConfigKey.LV0_BALANCE_MINIMUM]: 0,
    },
  });

  const {
    handleSubmit,
    reset,
    control,
    // getValues,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    load();
  }, [reload.value]);

  const load = async () => {
    try {
      initialize.onTrue();

      const query = {
        key: `${SystemConfigKey.LV0_BALANCE_MINIMUM}`,
      };
      const { data } = await axios.get<SettingType[]>(endpoints.settings.get, { params: query });

      setSettings(data);
      reset(data.reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {}));
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  };

  const onSubmit = handleSubmit(async (values) => {
    try {
      const body = Object.entries(values).map(([key, value]) => ({
        key,
        value: value || 0,
      }));
      await axios.post(endpoints.settings.createOrUpdate, { configs: body });
      enqueueSnackbar('บันทึกสำเร็จ');
      reload.onToggle();
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <LoadingContainer loading={initialize.value} sx={{ minHeight: '30vh' }} fitContent>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Card sx={{ py: 5, px: 3 }}>
          <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h6">จำนวนเงินขั้นต่ำของผู้ใช้งาน LV0</Typography>
              <Typography variant="caption" color="text.secondary">
                <UpdatedText
                  {...getSettingUpdated(settings, SystemConfigKey.LV0_BALANCE_MINIMUM)}
                />
              </Typography>
            </Stack>
            <Controller
              name={SystemConfigKey.LV0_BALANCE_MINIMUM}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="จำนวนเงินขั้นต่ำ (บาท)"
                  error={!!error}
                  helperText={error?.message}
                  sx={{ width: 1, maxWidth: '300px' }}
                  value={field.value ? fNumber(field.value, 0) : ''}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/,/g, '');
                    const parsedValue = parseFloat(numericValue) || 0;
                    field.onChange(parsedValue);
                  }}
                  onBlur={field.onBlur}
                  name={field.name}
                  ref={field.ref}
                />
              )}
            />

            <Box sx={{ mt: 2 }}>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={isSubmitting}
                sx={{ minWidth: 120 }}
              >
                บันทึก
              </LoadingButton>
            </Box>
          </Stack>
        </Card>
      </FormProvider>
    </LoadingContainer>
  );
}
